'use client';
import styled from 'styled-components';

import { SwiperSlide } from '@components/Carousel/Carousel';

export const CampaignContainer = styled.div`
  padding: 20px 0px;
  display: flex;
  flex-direction: column;

  gap: 20px;
  margin-bottom: 20px;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    gap: 40px;
  }

  & > a {
    display: block;

    ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
      display: none;
    }
  }
`;

export const CampainListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 24px;
  justify-items: center;

  & > *:nth-child(n + 5) {
    display: none;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 15px;
`;

export const SwipperSliderWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const CarouselWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
`;

export const SwiperSlider = styled(SwiperSlide)`
  &&& {
    width: 24%;

    height: 100%;

    margin-right: 20px;

    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      width: 100%;
      margin-right: 12px;
    }
  }
`;
